'use strict';

import * as types from '../../types';
import awsApi from '../../api/aws-api';
// import d3Api from '../../api/d3-api';
// import moment from 'moment';

// let LOCAL_STORAGE_KEY_USER_TOKEN            = 'ut';
// let LOCAL_STORAGE_KEY_USER_TOKEN_EXPIRED_AT = 'ute';

export default {
  /**
   * Cognitoで初期化
   * @param commit
   */
  [types.INITIALIZE_COGNITO]: function({commit, state}){
    function initialize(){
      awsApi.initializeCognito()
        .then((credentials)=>{
          commit(types.INITIALIZE_COGNITO, {credentials});
        })
        .catch((err)=>{
          // if(err.toString().indexOf('Invalid login token. Can\'t pass in a Cognito token.') > -1){
          //   // ログイントークンの有効期限切れてる可能性大
          //   logger('Expired');
          //   let expiredAt = localStorage.getItem(LOCAL_STORAGE_KEY_USER_TOKEN_EXPIRED_AT);
          //   if(moment(expiredAt).isAfter(new Date())){
          //     // まだ有効期限内
          //     let userToken = localStorage.getItem(LOCAL_STORAGE_KEY_USER_TOKEN);
          //     d3Api.getCredentialByUserToken(state.credentials, userToken)
          //       .then((identityData)=>{
          //         // IdentityIdとTokenが揃っていたら認証する
          //         if(identityData && identityData.IdentityId && identityData.Token){
          //           return awsApi.reInitializeCognito(identityData);
          //         }else{
          //           new Error('identityData not found');
          //         }
          //       })
          //       .catch((err)=>{
          //         logger('#####', err);
          //       });
          //   }
          // }else{
          //   logger('HOGEGE', err);
          // }
          logger('### Error', err);
        });
    }
    
    //if(!state.cognitoIdentityId){
    initialize();
    //}
  },
  
  /**
   * COGNITOのクレデンシャルを更新。だいたいは有効期限切れる前に呼ばれる
   * @param commit
   * @param state
   */
  [types.UPDATE_COGNITO_CREDENTIALS]: function({commit, state}){
    /*awsApi.initializeCognito()
      .then((credentials)=>{
        commit(types.INITIALIZE_COGNITO, {credentials});
      })
      .catch((err)=>{
        
      });*/
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js